module.exports = __webpack_public_path__ + "img/Annie_Moberg.d1336300.png";